<template lang="pug">
  .home

    include mixins.pug

    Navbar
    .section.list(v-if='!showDetail')
      .subtitle Planes
      .level.panel
        form(@submit.prevent='searchAction').level-left
          .level-item
            input.input(placeholder='Descripción' v-model='search.descrip')
          .level-item
            button.button.is-primary(:class="{'is-loading': searching}") Buscar
      progress.progress.is-small.is-primary(v-if='searching' max='100') 50

      table.table.is-bordered.is-striped.is-fullwidth.is-hoverable
        thead
          tr
            th Tipo de Crédito
            th Descripción
            th Monto del crédito
            th Cuota
            th Interés diario
            th Interés total
            th Cod Iad
            th Cod Ic
            th Int Cobr
            th Clase
            th Cuota Cred
            th Serv Cobr
            th Bonoficación por promoción
            th Código gasto bonificación
            th Acciones
        tbody(v-for='row in planesList')
          tr
            td {{ row.plan }}
            td {{ row.descrip }}
            td {{ row.monto_cred }}
            td {{ row.cuota }}
            td {{ row.int_dia }}
            td {{ row.int_total }}
            td {{ row.cod_iad }}
            td {{ row.cod_ic }}
            td {{ row.int_cobr }}
            td {{ row.clase }}
            td {{ row.cuota_cred }}
            td {{ row.serv_cobr }}
            td {{ row.bonif_x_p ? 'Si' : 'No' }}
            td {{ row.cod_g_bon }}
            td.has-text-centered
              button.button.is-primary(@click.prevent='verDatos(row)') Datos

    .section.detail(v-else @keyup.esc='showDetail = false')
      h1.title Detalles de planes
        form.form
          .columns
            +textField('Tipo de Crédito', 'planesInstance.plan', 'planInput')
            +textField('Descripción', 'planesInstance.descrip')
          .columns
            +textField('Monto del crédito', 'planesInstance.monto_cred')
            +textField('Cuota', 'planesInstance.cuota')
          .columns
            +textField('Número de Cuotas', 'planesInstance.nro_cuo')
            +textField('Interés diario', 'planesInstance.int_dia')
          .columns
            +textField('Interés total', 'planesInstance.int_total')
            +textField('Comision', 'planesInstance.comision')
          .columns
            +textField('Cuota Cobr', 'planesInstance.cuota_cobr')
            +checkboxField('Dias', 'planesInstance.dias')
          .columns
            +textField('Cod Cac', 'planesInstance.cod_cac')
            +textField('Cod Iad', 'planesInstance.cod_iad')
          .columns
            +textField('Cod Ic', 'planesInstance.cod_ic')
            +textField('Caja', 'planesInstance.caja')
          .columns
            +textField('Cred Ac', 'planesInstance.cred_ac')
            +textField('Int A Dev', 'planesInstance.int_a_dev')
          .columns
            +textField('Int Cobr', 'planesInstance.int_cobr')
            +textField('Clase', 'planesInstance.clase')
          .columns
            +textField('Interes1', 'planesInstance.interes1')
            +textField('Gastos Ad1', 'planesInstance.gastos_ad1')
          .columns
            +textField('Interes2', 'planesInstance.interes2')
            +textField('Gastos Ad2', 'planesInstance.gastos_ad2')
          .columns
            +textField('Cuota Cred', 'planesInstance.cuota_cred')
            +textField('Serv Cobr', 'planesInstance.serv_cobr')
          .columns
            +checkboxField('Bonoficación por promoción', 'planesInstance.bonif_x_p')
            +textField('Código gasto bonificación', 'planesInstance.cod_g_bon')
          button.button.is-info(@click.prevent='showDetail = false') Volver

</template>

<script>

import Navbar from '@/components/Navbar.vue'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

async function busqueda(search) {
  var query = firebase.firestore().collection('planes').limit(100)

  // firebase no soporte rage search (<=, >=, etc.) con más de un campo.
  if(search.descrip) 
    query = query.where('descrip', '>=', search.descrip)
  let planesList = []

  return query.get().then(snapshot => {
    snapshot.forEach(doc => planesList.push(doc.data()))
    return planesList
  })
}

export default {
  data () {
    return {
      planesList: [],
      planesInstance: {}, 
      search: {
        descrip: null,
      },
      searching: false,
      showDetail: false
    }
  },
  filters: {
    dateFmt(date) {
      if (date)
        return date.split('T')[0]
      return date
    }
  },
  components: {
    Navbar
  },
  created: function() {
    this.searching = true
    firebase.auth().onAuthStateChanged(user => {
      busqueda(this.search).then(list => {
        this.planesList = list
        this.searching = false
      })
    })
  },
  methods: {
    searchAction: function () {
      this.searching = true
      busqueda(this.search).then(list => {
        this.planesList = list
        this.searching = false
      })
    },
    verDatos: function (instance) {
      this.planesInstance = instance
      this.showDetail = true
      this.$nextTick(() => this.$refs.planInput.focus())
    }
  }
}
</script>
